// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: zdbHibLQVF

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicEditTitleButton.module.css"; // plasmic-import: zdbHibLQVF/css

import PenIconsvgIcon from "./icons/PlasmicIcon__PenIconsvg"; // plasmic-import: 9mg4c9PZwc/icon
import PenIconWithLinessvgIcon from "./icons/PlasmicIcon__PenIconWithLinessvg"; // plasmic-import: Frs_68L0hd/icon

createPlasmicElementProxy;

export type PlasmicEditTitleButton__VariantMembers = {
  isTitleHovered: "isTitleHovered";
};
export type PlasmicEditTitleButton__VariantsArgs = {
  isTitleHovered?: SingleBooleanChoiceArg<"isTitleHovered">;
};
type VariantPropType = keyof PlasmicEditTitleButton__VariantsArgs;
export const PlasmicEditTitleButton__VariantProps = new Array<VariantPropType>(
  "isTitleHovered"
);

export type PlasmicEditTitleButton__ArgsType = {};
type ArgPropType = keyof PlasmicEditTitleButton__ArgsType;
export const PlasmicEditTitleButton__ArgProps = new Array<ArgPropType>();

export type PlasmicEditTitleButton__OverridesType = {
  editTitleButton?: p.Flex<"button">;
  svg?: p.Flex<"svg">;
};

export interface DefaultEditTitleButtonProps {
  isTitleHovered?: SingleBooleanChoiceArg<"isTitleHovered">;
  className?: string;
}

const $$ = {};

function PlasmicEditTitleButton__RenderFunc(props: {
  variants: PlasmicEditTitleButton__VariantsArgs;
  args: PlasmicEditTitleButton__ArgsType;
  overrides: PlasmicEditTitleButton__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "isTitleHovered",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isTitleHovered
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const [isEditTitleButtonHover, triggerEditTitleButtonHoverProps] = useTrigger(
    "useHover",
    {}
  );
  const triggers = {
    hover_editTitleButton: isEditTitleButtonHover
  };

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    (
      triggers.hover_editTitleButton
        ? true
        : hasVariant($state, "isTitleHovered", "isTitleHovered")
        ? true
        : false
    ) ? (
      <button
        data-plasmic-name={"editTitleButton"}
        data-plasmic-override={overrides.editTitleButton}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.button,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          projectcss.plasmic_tokens,
          plasmic_antd_5_hostless_css.plasmic_tokens,
          plasmic_plasmic_rich_components_css.plasmic_tokens,
          plasmic_pro_pro_css.plasmic_tokens,
          sty.editTitleButton,
          {
            [projectcss.global_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            ),
            [sty.editTitleButtonisTitleHovered]: hasVariant(
              $state,
              "isTitleHovered",
              "isTitleHovered"
            )
          }
        )}
        ref={ref => {
          $refs["editTitleButton"] = ref;
        }}
        data-plasmic-trigger-props={[triggerEditTitleButtonHoverProps]}
      >
        <p.PlasmicIcon
          data-plasmic-name={"svg"}
          data-plasmic-override={overrides.svg}
          PlasmicIconType={
            triggers.hover_editTitleButton
              ? PenIconWithLinessvgIcon
              : hasVariant($state, "isTitleHovered", "isTitleHovered")
              ? PenIconWithLinessvgIcon
              : PenIconsvgIcon
          }
          className={classNames(projectcss.all, sty.svg, {
            [sty.svgisTitleHovered]: hasVariant(
              $state,
              "isTitleHovered",
              "isTitleHovered"
            )
          })}
          role={"img"}
        />
      </button>
    ) : null
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  editTitleButton: ["editTitleButton", "svg"],
  svg: ["svg"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  editTitleButton: "button";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicEditTitleButton__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicEditTitleButton__VariantsArgs;
    args?: PlasmicEditTitleButton__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicEditTitleButton__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicEditTitleButton__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicEditTitleButton__ArgProps,
          internalVariantPropNames: PlasmicEditTitleButton__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicEditTitleButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "editTitleButton") {
    func.displayName = "PlasmicEditTitleButton";
  } else {
    func.displayName = `PlasmicEditTitleButton.${nodeName}`;
  }
  return func;
}

export const PlasmicEditTitleButton = Object.assign(
  // Top-level PlasmicEditTitleButton renders the root element
  makeNodeComponent("editTitleButton"),
  {
    // Helper components rendering sub-elements
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicEditTitleButton
    internalVariantProps: PlasmicEditTitleButton__VariantProps,
    internalArgProps: PlasmicEditTitleButton__ArgProps
  }
);

export default PlasmicEditTitleButton;
/* prettier-ignore-end */
